<script lang="ts">
    import s from './svg-icon.module.css';
    import cn from 'classnames';
    import type { Props } from './types';

    export let icon: Props['icon'];
    export let rotationAngle: Props['rotationAngle'] = 0;
    export let classes: Props['classes'] = null;
    export let svgClasses: Props['svgClasses'] = null;
    export let width: Props['width'] = 20;
    export let tagName: Props['tagName'] = 'span';
    export let attrs: Props['attrs'] = {};
    export let svgStyle: Props['svgStyle'] = null;
    export let color: Props['color'] = null;
    export let alwaysBlack: Props['alwaysBlack'] = false;
    export let alwaysWhite: Props['alwaysWhite'] = false;

    $: colorCN = color && !alwaysBlack && !alwaysWhite ? s[color] : null;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
    this={tagName}
    on:click
    class={cn(s.root, colorCN, { [s.black]: alwaysBlack }, { [s.white]: alwaysWhite }, classes)}
    data-testid="svg-icon"
    {...attrs}
>
    <svg
        viewBox={icon.viewBox}
        {width}
        style={svgStyle}
        class={cn(s.icon, { [s[`rotate-${rotationAngle}`]]: rotationAngle }, svgClasses)}
    >
        <use id={icon.id} xlink:href={icon.url} />
    </svg>
</svelte:element>
